var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldMusicLibrary2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4.75V3.26c0-.83-.68-1.51-1.51-1.51H9.51C8.68 1.75 8 2.43 8 3.26v1.49H7c-1.1 0-2 .9-2 2v.13c.32-.09.65-.13 1-.13h12c.35 0 .68.04 1 .13v-.13c0-1.1-.9-2-2-2h-1zM13.36 17.5c0 .31.26.57.57.57.31 0 .57-.26.57-.57a.57.57 0 1 0-1.14 0zM8.5 18.379c0 .31.26.57.57.57a.57.57 0 1 0-.57-.57z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8.25H6c-.35 0-.68.04-1 .13-1.72.45-3 2.02-3 3.87v6c0 2.2 1.8 4 4 4h12c2.2 0 4-1.8 4-4v-6c0-1.85-1.28-3.42-3-3.87-.32-.09-.65-.13-1-.13zm-2 9.25c0 1.14-.93 2.07-2.07 2.07-1.14 0-2.07-.93-2.07-2.07 0-1.14.93-2.07 2.07-2.07.2 0 .39.04.57.09v-1.26l-3.35.91v3.21c0 .01 0 .02-.01.03a2.077 2.077 0 0 1-2.07 2.05c-1.14 0-2.07-.93-2.07-2.08s.93-2.07 2.07-2.07c.2 0 .39.04.58.09v-3.35c0-.86.54-1.56 1.36-1.78l2.65-.73c.85-.23 1.39-.01 1.69.22.3.23.65.68.65 1.57v5.17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMusicLibrary2);
export default __webpack_public_path__ + "static/media/vuesax-bold-music-library-2.18935e2a5353f049a4ec5c34d07e4223.svg";
export { ForwardRef as ReactComponent };